<template>
    <Breadcrumbs main="Job Search" title="Apply" />
    <div class="container-fluid">
        <div class="row">
            <jobSidebar />
            <jobApply />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const jobSidebar = defineAsyncComponent(() => import("@/components/commen/jobSidebar.vue"))
const jobApply = defineAsyncComponent(() => import("@/components/theme/job/apply/jobApply.vue"))
</script>